import React, { useContext } from "react";
import { CheckLabel, LoadingDots, Page, PageNotFound, Tabs } from "@sscs/ui";
import { Link, Navigate, Outlet, useLocation, useOutletContext, useSearchParams, } from "react-router";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { ReportContext } from "../../context";
import { useGetDiffSummaryQuery } from "../../services/diff.api";
import { useGetReportSummaryQuery } from "../../services/shared.api";
import DiffHeader from "../common/DiffHeader/DiffHeader";
import { DIFF_CHECK_TEXT } from "../common/summary/diffCheckText";
const TAB_ROUTES = [
    REPORT_PAGES_ROUTES.VERSION_DIFF_THREAT_HUNTING,
    REPORT_PAGES_ROUTES.VERSION_DIFF_ISSUE_CHANGES,
    REPORT_PAGES_ROUTES.VERSION_DIFF_FILE_CHANGES,
];
export const useVersionDiffContext = () => useOutletContext();
export const VersionDiffIndex = () => {
    const { hasIssues } = useVersionDiffContext();
    const [searchParams] = useSearchParams();
    return (React.createElement(Navigate, { to: {
            pathname: hasIssues
                ? REPORT_PAGES_ROUTES.VERSION_DIFF_THREAT_HUNTING
                : REPORT_PAGES_ROUTES.VERSION_DIFF_ISSUE_CHANGES,
            search: searchParams.toString(),
        }, relative: "path", replace: true }));
};
const VersionDiff = () => {
    var _a;
    const { reportId, diffId, selectedCheck } = useContext(ReportContext);
    const { pathname } = useLocation();
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    }, { skip: !diffId });
    const { data: diffSummaryData } = useGetDiffSummaryQuery({
        ui_id: diffId,
    }, { skip: !diffId });
    const scanReport = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.checks_report.report.scans[selectedCheck];
    if (!diffId)
        return (React.createElement(PageNotFound, { title: "Page not found", byline: "This version has no comparison to display." }));
    if (!reportSummaryData || !diffSummaryData || !scanReport)
        return React.createElement(LoadingDots, null);
    const stats = (_a = reportSummaryData.counters.diff) !== null && _a !== void 0 ? _a : {
        diff_violations: 0,
        introduced_issues: 0,
        resolved_issues: 0,
        total_changes: 0,
    };
    const hasIssues = diffSummaryData.issues.length > 0;
    const lastSegment = pathname.split("/").pop();
    const activeTab = lastSegment && TAB_ROUTES.includes(lastSegment)
        ? lastSegment
        : REPORT_PAGES_ROUTES.VERSION_DIFF_ISSUE_CHANGES;
    return (React.createElement(Page.Root, null,
        React.createElement(DiffHeader, { title: "Version diff", statusLabel: React.createElement(CheckLabel, { status: diffSummaryData.status, isDiffCheck: true }), failed: diffSummaryData.status === "fail", description: DIFF_CHECK_TEXT[diffSummaryData.status], glyph: "compare", files: [
                {
                    id: "diff-modified-copy-hash-to-clipboard",
                    label: "Modified file",
                    info: scanReport.artifact,
                },
                {
                    id: "diff-referential-copy-hash-to-clipboard",
                    label: "Referential file",
                    info: diffSummaryData.source,
                },
            ] }),
        React.createElement(Page.Tabs, null,
            React.createElement(Tabs.Tabs, { value: activeTab },
                hasIssues ? (React.createElement(Tabs.Tab, { id: "version-diff-threat-hunting-tab", value: REPORT_PAGES_ROUTES.VERSION_DIFF_THREAT_HUNTING, to: REPORT_PAGES_ROUTES.VERSION_DIFF_THREAT_HUNTING, component: Link, label: "Threat hunting", count: diffSummaryData.issues.length })) : null,
                React.createElement(Tabs.Tab, { id: "version-diff-issue-changes-tab", value: REPORT_PAGES_ROUTES.VERSION_DIFF_ISSUE_CHANGES, to: REPORT_PAGES_ROUTES.VERSION_DIFF_ISSUE_CHANGES, component: Link, label: "Issue changes", count: stats.introduced_issues + stats.resolved_issues }),
                React.createElement(Tabs.Tab, { id: "version-diff-file-changes-tab", value: REPORT_PAGES_ROUTES.VERSION_DIFF_FILE_CHANGES, to: REPORT_PAGES_ROUTES.VERSION_DIFF_FILE_CHANGES, component: Link, label: "File changes", count: stats.total_changes }))),
        React.createElement(Outlet, { context: {
                issues: diffSummaryData.issues,
                stats,
                hasIssues,
            } })));
};
export default VersionDiff;
//# sourceMappingURL=VersionDiff.js.map